export const WCAG_LEVELS = [
  { value: 'wcag2a', label: 'WCAG 2.1 Level A' },
  { value: 'wcag2aa', label: 'WCAG 2.1 Level AA (Recommended)' },
  { value: 'wcag2aaa', label: 'WCAG 2.1 Level AAA' },
]

export const SCAN_TYPES = [
  { value: 'single', label: 'Single Page' },
  { value: 'multi', label: 'Multi-Page Crawl' },
]

export const NAVIGATION_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: 'mdi:chart-line', path: '/dashboard' },
  // { id: 'scans', label: 'Scans', icon: 'mdi:magnify', path: '/scans' },
  // { id: 'analytics', label: 'Analytics', icon: 'mdi:chart-bar', path: '/analytics' },
  { id: 'website-connections', label: 'Website Connections', icon: 'mdi:web', path: '/website-connections' },
  { id: 'integrations', label: 'Scans', icon: 'mdi:link-variant', path: '/integrations' },
  { id: 'scan-planner', label: 'Scan Planner', icon: 'mdi:calendar-clock', path: '/scan-planner' },
  { id: 'compliance', label: 'Compliance', icon: 'mdi:gavel', path: '/compliance' },
  { id: 'team', label: 'Team', icon: 'mdi:account-group', path: '/team' },
  { id: 'api-management', label: 'Plugin License', icon: 'mdi:key-variant', path: '/api-management' },
  { id: 'billing', label: 'Billing', icon: 'mdi:credit-card', path: '/billing' },
  { id: 'settings', label: 'Settings', icon: 'mingcute:settings-2-fill', path: '/settings' },
]

export const VIOLATION_IMPACT_COLORS = {
  critical: 'text-red-600 bg-red-50',
  serious: 'text-orange-600 bg-orange-50',
  moderate: 'text-yellow-600 bg-yellow-50',
  minor: 'text-blue-600 bg-blue-50',
}
